import React from "react";
import * as Yup from "yup";

const ProfessorValidation = Yup.object({
  firstName: Yup.string()
    .max(32, "First name must be at most 32 characters")
    .required("Required*"),
  lastName: Yup.string()
    .max(32, "Last name must be at most 32 characters")
    .required("Required*"),
  university: Yup.string()
    .max(32, "University name must be at most 32 characters")
    .required("Required*"),
  email: Yup.string()
    .required("Required*")
    .max(64)
    .email("Oops, that doesn’t look like an email address*")
    .typeError("A number is required"),
  password: Yup.string()
    .required("Required*")
    .min(8, "Your password must be at least 8 characters*")
    .max(64)
    .matches(
      /(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=)/,
      "Your password must contain at least 1 number and one special character"
    ),
  confirmPassword: Yup.string()
    .required("Required*")
    .oneOf([Yup.ref("password"), null], "Your passwords do not match."),
});

export default ProfessorValidation;
